import { Link } from '@tanstack/react-router';
import styled from 'styled-components';

import { Button } from '../../cdl/Button/Button';
import { Text } from '../../cdl/Text/Text';
import { ButtonGroup } from '../buttons/ButtonGroup';
import { translate } from '../helpers/translate.helper';
import { useOpenFreshchat } from '../hooks/useOpenFreshchat';
import { useRole } from '../hooks/useRole';
import { CloselinkWordmark } from '../icons/closelink/CloselinkWordmark';
import { Box } from '../ui/Box';
import { theme } from '../ui/theme';

const ErrorPageSupportButton = styled.button`
    height: 32px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 14px;
    font-weight: ${theme.fontWeights[500]};
    text-align: left;
    padding: 0px 8px;
    display: flex;
    align-items: center;

    &:hover {
        text-decoration: underline;
    }
`;

interface ErrorPageContentProps {
    errorCode: string;
    title: string;
    description: string;
}

export const ErrorPageContent = ({ errorCode, title, description }: ErrorPageContentProps) => {
    const openFreshchat = useOpenFreshchat();
    const role = useRole();

    const lineBreak = '\n';

    return (
        <>
            <Link to="/dashboard">
                <CloselinkWordmark
                    color="white"
                    height={20}
                    style={{
                        position: 'absolute',
                        top: 32,
                        left: 32,
                    }}
                />
            </Link>
            <Box display="grid" gap={32} padding={48} maxWidth="750px">
                <Box display="grid" gap={16}>
                    <Text variant="action" color="foreground.onEmphasis" style={{ textTransform: 'uppercase' }}>
                        {errorCode}
                    </Text>
                    <Text variant="display" color="foreground.onEmphasis">
                        {title.includes(lineBreak)
                            ? title.split(lineBreak).map((line, index) => (
                                  <span key={index}>
                                      {line}
                                      <br />
                                  </span>
                              ))
                            : title}
                    </Text>
                    <Text variant="body" color="foreground.onEmphasis">
                        {description.includes(lineBreak)
                            ? description.split(lineBreak).map((line, index) => (
                                  <span key={index}>
                                      {line}
                                      <br />
                                  </span>
                              ))
                            : description}
                    </Text>
                </Box>

                <ButtonGroup>
                    <Link to="/dashboard">
                        <Button>{translate('notFound.goToDashboard')}</Button>
                    </Link>
                    {role && !role.isSuperAdmin() ? (
                        <ErrorPageSupportButton onClick={openFreshchat}>
                            {translate('notFound.contactSupport')}
                        </ErrorPageSupportButton>
                    ) : null}
                </ButtonGroup>
            </Box>
        </>
    );
};
